import DeviceDetails from "../../../components/DeviceDetails";

const DeviceDetailsPage = () => {
    return <DeviceDetails />
}
export default DeviceDetailsPage;
